import { useNavigate } from 'react-router-dom';

export function UnauthorizedPage(): React.ReactElement {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <h1 className="text-4xl font-display font-bold text-foreground mb-4">Access Denied</h1>
        <p className="text-foreground-subtle mb-6">
          You do not have permission to access this page.
        </p>
        <div className="space-x-4">
          <button
            onClick={() => navigate(-1)}
            className="px-4 py-2 border border-border text-foreground rounded hover:bg-background-secondary"
          >
            Go Back
          </button>
          <button
            onClick={() => navigate('/')}
            className="px-4 py-2 bg-neon-cyan text-background font-medium rounded hover:opacity-90"
          >
            Go Home
          </button>
        </div>
      </div>
    </div>
  );
}
